<script>
import { mapGetters } from 'vuex';
import waselIllustration from 'dashboard/assets/images/wasel-no-chat.png';
import tradershubIllustration from 'dashboard/assets/images/tradershub-no-chat.svg';
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      accountBranding: 'globalConfig/accountBranding',
      globalConfig: 'globalConfig/get',
    }),
    hasAccountIllustration() {
      return Boolean(this.accountBranding?.conversationEmptyState);
    },
    illustration() {
      const defaultIllustration = ['ClientCare', 'TradersHub'].includes(
        this.globalConfig.installationName
      )
        ? tradershubIllustration
        : waselIllustration;
      return (
        this.accountBranding?.conversationEmptyState || defaultIllustration
      );
    },
    illustrationAlt() {
      return `${this.globalConfig.installationName || 'ClientCare'} conversations`;
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <img
      class="m-4"
      :class="hasAccountIllustration ? 'w-80 max-w-[calc(100%-2rem)]' : 'w-32'"
      :src="illustration"
      :alt="illustrationAlt"
    />
    <span class="text-sm text-n-slate-12 font-medium text-center">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
